module.exports = __webpack_public_path__ + "static/media/IMG_1406.dc350309.jpg";